export default {
	pc: {
		chinese: {
			banner: require('@/images/product/2-1.png'),
			slidingList: [
				"保理云",
				"票据云",
				// "票据秒融",
				"跨境云"
			],
			//金单
			jinBill: {
				title: '金单',
				partnerImg: require('@/images/product/2-9.png'),
				paragraph: '金单是指核心企业等应收账款债务人依据真实贸易关系，通过简单汇供应链信息服务系统向其链上企业等应收账款债权人出具的，承诺按期支付相应款项的电子化记录。',
				jindanList: [{
						iconPath: require("@/images/product/2-6.png"),
						title: "电子存证，安全可靠",
						desc: "企业间单据、协议、业务等信息均采用区块链技术存证，数据及时同步且可追溯，确保各参与方的权益"
					},
					{
						iconPath: require("@/images/product/2-7.png"),
						title: "按需拆转，便捷高效",
						desc: "企业签收金单后，可根据实际需求便捷转让应收账款债权，系统自动线上签署转让协议和通知债务人等"
					},
					{
						iconPath: require("@/images/product/2-8.png"),
						title: "智能服务，普惠周到",
						desc: "简单汇已完成主流银行系统直连，企业可线上向合作银行直接发起业务申请，系统自动受理，智能审核"
					}
				],

			},
			//供应链票据
			supplyBill: {
				title: '供应链票据',
				paragraph: '供应链票据是指企业通过符合上海票据交易所要求且系统对接的供应链平台开展的电子商业汇票业务，包含出票、承兑、背书、质押、保证、贴现、有限追索、信托直转等功能。',
				billList: [{
          iconPath: require("@/images/product/2-15.png"),
          title: '法定工具，系统互联',
          desc: "供应链票据属于法定商业汇票，通过票交所天然与市场所有参与者系统互通，可以与任意银行开展业务"
        },
        {
          iconPath: require("@/images/product/2-16.png"),
          title: '账户灵活，支付便捷',
          desc: "供应链票据系统支持企业绑定任意银行结算账户为票据清算账户，企业以此可办理所有银行的票据业务"
        },
        {
          iconPath: require("@/images/product/2-20.png"),
          title: '功能丰富，应用创新',
          desc: "供应链票据独有的有限追索、信托直转等新功能，能满足用票企业优化财报、丰富融资渠道等场景需求"
        }],
			},
			//金融平台
			financeImg: require('@/images/product/2-17.png'),
			//供应链票据资产证券化
			chainBillAndStandardizedBill: {
				title: '供应链票据资产证券化',
				paragraph: '供应链票据资产证券化是指由未贴现供应链票据或相关财产权利作为基础资产所产生的现金流作为主要偿付支持，发起机构通过特定目的载体发行资产支持票据（ABN）、资产支持商业票据（ABCP）等企业资产支持证券的业务活动。其创新在于发起机构可以将供应链票据直接转移给特定目的载体，然后供应链平台等主体也可以作为发起机构代理人。持票企业可以委托简单汇或指定其他主体为发起代理人，完成线上签约及票据直接转让等工作。',
				capitalImg: require('@/images/product/2-19.png'),
			},
			//跨境云
			huikeCloud: {
				title: '跨境保理',
				paragraph: '跨境保理是指进口商通过简单汇供应链信息服务系统，以电子签名的方式承诺在指定日期支付确定币种金额货款给出口商，从而实现与金融机构合作的线上化保理服务。',
				// 跨境云
        branchcloud: [
          {
						iconPath: require("@/images/product/hky-01.png"),
						title: "融通四海，账期无忧",
						desc: "覆盖全球业务网络，无论买家位于世界何处，都能通过简单汇实现便捷的应收账款管理和保理业务申请"
					},
					{
						iconPath: require("@/images/product/hky-02.png"),
						title: "币种丰富，按需选择",
						desc: "支持不同币种贸易背景，灵活按客户实际币种需求管理应收账款与办理保理业务，让资金安排随心所欲"
					},
					{
						iconPath: require("@/images/product/hky-03.png"),
						title: "流程无界，一站通达",
						desc: "简单汇系统直连银行系统，精简了跨境业务的单据审核、业务申请等流程，全线上操作，体验高效便捷"
					}
				]
			}
		},
		english: {
			banner: require('@/images/english/banner_product.png'),
			slidingListYW: [
				"Factoring Cloud",
				"Bill Cloud",
				"Cross-Border Cloud"
			],
			//金单
			jinBill: {
				title: 'JinDan',
				partnerImg:require('@/images/english/product_1.png'),
				paragraph: 'Jin Dan refers to an electronic record issued by accounts receivable debtors such as core enterprises to accounts receivable creditors such as their chain enterprises through the JDH Supply Chain Information Service System based on real trade relations, committing to pay the corresponding amount on schedule.',
				jindanListYW: [{
						iconPath: require("@/images/product/2-6.png"),
						title: "Electronic Evidence Storage, Safe and Reliable",
						desc: "Information such as documents, agreements, and business transactions between enterprises is stored using blockchain technology. Data is synchronized in a timely manner and traceable, ensuring the rights and interests of all participants"
					},
					{
						iconPath: require("@/images/product/2-7.png"),
						title: "Splittable and Transferable on Demand, Convenient and Efficient",
						desc: "After enterprises sign for Jin Dan, they can conveniently transfer accounts receivable claims according to actual needs. The system automatically signs transfer agreements online and notifies debtors, etc"
					},
					{
						iconPath: require("@/images/product/2-8.png"),
						title: "Intelligent Services, Inclusive and Thoughtful",
						desc: "JDH has completed direct connection with mainstream bank systems. Enterprises can directly initiate business applications to cooperative banks online, and the system automatically accepts and intelligently reviews them"
					}
				],
			},
			//供应链票据
			supplyBill: {
				title: 'Supply Chain Bill',
				paragraph: `Supply Chain Bill refers to electronic commercial draft transactions conducted by enterprises through supply chain platforms that comply with the requirements of the Shanghai Commercial Paper Exchange and are system-connected. Its functionalities include issuance, acceptance, endorsement, pledging, guarantee, discounting, limited recourse, and trust-based direct transfer`,
				billListYW: [{
          iconPath: require("@/images/product/2-15.png"),
          title: 'Statutory Instrument, System Interoperability',
          desc: "Supply Chain Bill is a statutory commercial bill. Through Shanghai Commercial Paper Exchange , it is naturally interconnected with the systems of all market participants and can conduct business with any bank"
        },
        {
          iconPath: require("@/images/product/2-16.png"),
          title: 'Flexible Accounts, Convenient Payment',
          desc: "The Supply Chain Bill system supports enterprises to bind any bank settlement account as the bill clearing account, through which enterprises can handle bill business with all banks"
        },
        {
          iconPath: require("@/images/product/2-20.png"),
          title: 'Rich Functions, Innovative Application',
          desc: "The unique new functions of Supply Chain Bill, such as limited recourse and direct trust transfer, can meet the needs of bill-using enterprises in scenarios such as optimizing financial reports and enriching financing channels"
        }],
			},
			//金融平台
			financeImg: require('@/images/english/product_2.png'),
			//供应链票据资产证券化
			chainBillAndStandardizedBill: {
				title: 'Supply Chain Bills asset securitization',
				paragraph: 'Supply Chain Bills securitization involves using undiscounted Supply Chain Bills or related property rights as the primary asset to generate cash flows, which serve as the main repayment support. The initiating institution issues asset-backed securities (ABNs) and asset-backed commercial papers (ABCPs) through a specific purpose vehicle. The innovation lies in the ability of the initiating institution to directly transfer the Supply Chain Bill to a specific purpose vehicle, with the supply chain platform acting as an agent for the initiating institution. The holder of the Bill can entrust JDH or other designated entities as agents to complete online signing and direct bills transfer.',
				capitalImg: require('@/images/english/product_3.png')
			},
			//跨境云
			huikeCloud: {
				title: 'Cross-Border Factoring',
				paragraph: `Cross-Border Factoring refers to an online factoring service where importers commit to pay a certain amount in a specified currency to exporters on a designated date via electronic signature through the JDH Supply Chain Information Service System, thereby cooperating with financial institutions.`,
				// 跨境保理
        branchcloudYW: [
          {
						iconPath: require("@/images/product/hky-01.png"),
						title: "Connect Globally, Settle Easily",
						desc: "Covering a global business network, no matter where the buyer is in the world, enterprises can realize convenient accounts receivable management and factoring business applications through JDH"
					},
					{
						iconPath: require("@/images/product/hky-02.png"),
						title: "Wide Selection of Currencies, On-Demand Choice",
						desc: `Full support for multi-currency trade backgrounds, flexible management of receivables and factoring operations tailored to clients' actual currency needs, enabling ultimate freedom in capital arrangement`
					},
					{
						iconPath: require("@/images/product/hky-03.png"),
						title: "Seamless Processes, One-Stop Access",
						desc: `JDH system is directly connected to bank systems, simplifying processes such as document review and business application for cross-border business. The entire process is operated online, providing an efficient and convenient experience`
					}
        ]
			}
		}
	},
	phone: {
		chinese: {
			banner: require('@/images/mobile/product/1-0.png'),
			slidingList: [
				"保理云",
				"票据云",
				// "票据秒融",
				"跨境云"
			],
			//金单
			jinBill: {
				title: '金单',
				partnerImg:require('@/images/mobile/product/1-6.png'),
				paragraph: '金单是指核心企业等应收账款债务人依据真实贸易关系，通过简单汇供应链信息服务系统向其链上企业等应收账款债权人出具的，承诺按期支付相应款项的电子化记录。',
				jindanList: [{
						iconPath: require("@/images/mobile/product/1-2.png"),
						title: "电子存证，安全可靠",
						desc: "企业间单据、协议、业务等信息均采用区块链技术存证，数据及时同步且可追溯，确保各参与方的权益"
					},
					{
						iconPath: require("@/images/mobile/product/1-3.png"),
						title: "按需拆转，便捷高效",
						desc: "企业签收金单后，可根据实际需求便捷转让应收账款债权，系统自动线上签署转让协议和通知债务人等"
					},
					{
						iconPath: require("@/images/mobile/product/1-4.png"),
						title: "智能服务，普惠周到",
						desc: "简单汇已完成主流银行系统直连，企业可线上向合作银行直接发起业务申请，系统自动受理，智能审核"
					}
				],
			},
			//供应链票据
			supplyBill: {
				title: '供应链票据',
				paragraph: '供应链票据是指企业通过符合上海票据交易所要求且系统对接的供应链平台开展的电子商业汇票业务，包含出票、承兑、背书、质押、保证、贴现、有限追索、信托直转等功能。',
				billList: [{
          iconPath: require("@/images/product/2-15.png"),
          title: '法定工具，系统互联',
          desc: "供应链票据属于法定商业汇票，通过票交所天然与市场所有参与者系统互通，可以与任意银行开展业务"
        },
        {
          iconPath: require("@/images/product/2-16.png"),
          title: '账户灵活，支付便捷',
          desc: "供应链票据系统支持企业绑定任意银行结算账户为票据清算账户，企业以此可办理所有银行的票据业务"
        },
        {
          iconPath: require("@/images/product/2-20.png"),
          title: '功能丰富，应用创新',
          desc: "供应链票据独有的有限追索、信托直转等新功能，能满足用票企业优化财报、丰富融资渠道等场景需求"
        }],
			},
			//金融平台
			financeImg: require('@/images/mobile/product/1-7.png'),
			//供应链票据资产证券化
			chainBillAndStandardizedBill: {
				title: '供应链票据资产证券化',
				paragraph: '供应链票据资产证券化是指由未贴现供应链票据或相关财产权利作为基础资产所产生的现金流作为主要偿付支持，发起机构通过特定目的载体发行资产支持票据（ABN）、资产支持商业票据（ABCP）等企业资产支持证券的业务活动。其创新在于发起机构可以将供应链票据直接转移给特定目的载体，然后供应链平台等主体也可以作为发起机构代理人。持票企业可以委托简单汇或指定其他主体为发起代理人，完成线上签约及票据直接转让等工作。',
				capitalImg: require('@/images/mobile/product/1-8.png'),
			},
			//跨境云
			huikeCloud: {
				title: '跨境保理',
				paragraph: '跨境保理是指进口商通过简单汇供应链信息服务系统，以电子签名的方式承诺在指定日期支付确定币种金额货款给出口商，从而实现与金融机构合作的线上化保理服务。',
				// 跨境云
        branchcloud: [
          {
						iconPath: require("@/images/mobile/product/hky-01.png"),
						title: "融通四海，账期无忧",
						desc: "覆盖全球业务网络，无论买家位于世界何处，都能通过简单汇实现便捷的应收账款管理和保理业务申请"
					},
					{
						iconPath: require("@/images/mobile/product/hky-02.png"),
						title: "币种丰富，按需选择",
						desc: "支持不同币种贸易背景，灵活按客户实际币种需求管理应收账款与办理保理业务，让资金安排随心所欲"
					},
					{
						iconPath: require("@/images/mobile/product/hky-03.png"),
						title: "流程无界，一站通达",
						desc: "简单汇系统直连银行系统，精简了跨境业务的单据审核、业务申请等流程，全线上操作，体验高效便捷"
					}
				]
			}
		},
		english: {
			banner:require('@/images/mobile/english/banner_product.png'),
			slidingListYW: [
				"Factoring Cloud",
				"Bill Cloud",
				"Cross-Border Cloud"
			],
			//金单
			jinBill: {
				title: 'JinDan',
				partnerImg:require('@/images/mobile/english/product_1.png'),
				paragraph: 'Jin Dan refers to an electronic record issued by accounts receivable debtors such as core enterprises to accounts receivable creditors such as their chain enterprises through the JDH Supply Chain Information Service System based on real trade relations, committing to pay the corresponding amount on schedule.',
				jindanListYW: [{
						iconPath: require("@/images/mobile/product/1-2.png"),
						title: "Electronic Evidence Storage, Safe and Reliable",
						desc: "Information such as documents, agreements, and business transactions between enterprises is stored using blockchain technology. Data is synchronized in a timely manner and traceable, ensuring the rights and interests of all participants"
					},
					{
						iconPath: require("@/images/mobile/product/1-3.png"),
						title: "Splittable and Transferable on Demand, Convenient and Efficient",
						desc: "After enterprises sign for Jin Dan, they can conveniently transfer accounts receivable claims according to actual needs. The system automatically signs transfer agreements online and notifies debtors, etc"
					},
					{
						iconPath: require("@/images/mobile/product/1-4.png"),
						title: "Intelligent Services, Inclusive and Thoughtful",
						desc: "JDH has completed direct connection with mainstream bank systems. Enterprises can directly initiate business applications to cooperative banks online, and the system automatically accepts and intelligently reviews them"
					}
				],
			},
			//供应链票据
			supplyBill: {
				title: 'Supply Chain Bill',
				paragraph: `Supply Chain Bill refers to electronic commercial draft transactions conducted by enterprises through supply chain platforms that comply with the requirements of the Shanghai Commercial Paper Exchange and are system-connected. Its functionalities include issuance, acceptance, endorsement, pledging, guarantee, discounting, limited recourse, and trust-based direct transfer`,
				billListYW: [{
          iconPath: require("@/images/product/2-15.png"),
          desc: "Supply Chain Bill is a statutory commercial bill. Through Shanghai Commercial Paper Exchange , it is naturally interconnected with the systems of all market participants and can conduct business with any bank"
        },
        {
          iconPath: require("@/images/product/2-16.png"),
          desc: "The Supply Chain Bill system supports enterprises to bind any bank settlement account as the bill clearing account, through which enterprises can handle bill business with all banks"
        },
        {
          iconPath: require("@/images/product/2-20.png"),
          title: 'Rich Functions, Innovative Application',
          desc: "The unique new functions of Supply Chain Bill, such as limited recourse and direct trust transfer, can meet the needs of bill-using enterprises in scenarios such as optimizing financial reports and enriching financing channels"
        }],
			},
			//金融平台
			financeImg: require('@/images/mobile/english/product_2.png'),
			//供应链票据资产证券化
			chainBillAndStandardizedBill: {
				title: 'Supply Chain Bills asset securitization',
				paragraph: 'Supply Chain Bills securitization involves using undiscounted Supply Chain Bills or related property rights as the primary asset to generate cash flows, which serve as the main repayment support. The initiating institution issues asset-backed securities (ABNs) and asset-backed commercial papers (ABCPs) through a specific purpose vehicle. The innovation lies in the ability of the initiating institution to directly transfer the Supply Chain Bill to a specific purpose vehicle, with the supply chain platform acting as an agent for the initiating institution. The holder of the Bill can entrust JDH or other designated entities as agents to complete online signing and direct bills transfer.',
				capitalImg: require('@/images/mobile/english/product_3.png')
			},
			//跨境云
			huikeCloud: {
				title: 'Cross-Border Factoring',
				paragraph: `Cross-Border Factoring refers to an online factoring service where importers commit to pay a certain amount in a specified currency to exporters on a designated date via electronic signature through the JDH Supply Chain Information Service System, thereby cooperating with financial institutions.`,
				// 跨境保理
        branchcloudYW: [
          {
						iconPath: require("@/images/mobile/product/hky-01.png"),
						title: "Connect Globally, Settle Easily",
						desc: "Covering a global business network, no matter where the buyer is in the world, enterprises can realize convenient accounts receivable management and factoring business applications through JDH"
					},
					{
						iconPath: require("@/images/mobile/product/hky-02.png"),
						title: "Wide Selection of Currencies, On-Demand Choice",
						desc: `Full support for multi-currency trade backgrounds, flexible management of receivables and factoring operations tailored to clients' actual currency needs, enabling ultimate freedom in capital arrangement`
					},
					{
						iconPath: require("@/images/mobile/product/hky-03.png"),
						title: "Seamless Processes, One-Stop Access",
						desc: `JDH system is directly connected to bank systems, simplifying processes such as document review and business application for cross-border business. The entire process is operated online, providing an efficient and convenient experience`
					}
        ]
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/lang/product.js